import React from "react";

import { useGetFootprintingFarmPrimaryDataById, useTranslation } from "utils";

import { AlertBanner, Card, Flex, Icon, PageSpin, Tag, Typography } from "components";

interface FarmGeneralProps {
  primaryDataId?: string;
}

const INFO_ITEMS = [
  "farmGettingStartedForm.info.gain",
  "farmGettingStartedForm.info.breakdown",
  "farmGettingStartedForm.info.compare",
  "farmGettingStartedForm.info.discover",
  "farmGettingStartedForm.info.track",
];

const FARM_LIST_FILES = ["electricityBill", "fuelInvoices", "fertiliserAndInputInvoices", "wasteDisposalRecords", "landUseChangeRecords"];

const FarmGettingStartedForm = ({ primaryDataId }: FarmGeneralProps) => {
  const { t } = useTranslation("footprintingFarm");

  const farmPrimaryDataQuery = useGetFootprintingFarmPrimaryDataById(primaryDataId ?? "");

  if (primaryDataId && farmPrimaryDataQuery.isLoading) return <PageSpin />;

  return (
    <Flex vertical gap={16}>
      <Card dataTestId="footprinting-farm-getting-started-form" border className="padding-200">
        {/* TODO: Replace with non-AI image */}
        {/* <Flex gap="1rem" vertical>
          <LazyLoadImage alt={"/images/onboarding/farm.webp"} aria-label="farm-logo-image" src={"/images/onboarding/farm.jpg"} />
        </Flex> */}
        <Flex gap={8} vertical>
          {INFO_ITEMS.map((item) => (
            <Flex key={item} align="center" gap={8}>
              <Icon size={24} iconName="tabler/circle-check" className="input-label-info-icon margin-left-0" />
              <Typography variant="paragraph-m">{t(item)}</Typography>
            </Flex>
          ))}
        </Flex>
      </Card>

      <Card border>
        <Flex vertical gap={24} className="padding-200">
          <Flex vertical gap={4}>
            <Flex justify="space-between" align="center">
              <Typography variant="h3">{t("farmGettingStartedForm.documents")}</Typography>
              <Tag size="large" text={t("farmGettingStartedForm.tag")} className="center" />
            </Flex>
            <Typography variant="paragraph-m" color="grey-600" className="margin-0">
              {t("farmGettingStartedForm.documentsDescription")}
            </Typography>
          </Flex>

          <Flex vertical gap={4}>
            {FARM_LIST_FILES.map((file) => (
              <div key={file}>
                <Typography variant="paragraph-m" className="margin-right-50">
                  •
                </Typography>
                <Typography variant="paragraph-m">{t(`farmGettingStartedForm.farmListFiles.${file}`)}</Typography>
              </div>
            ))}
          </Flex>

          <AlertBanner
            headingSize="h6"
            gap={12}
            title={t("farmGettingStartedForm.alertBanner.title")}
            description={t("farmGettingStartedForm.alertBanner.description")}
            iconName="tabler/bulb"
            iconSize={24}
            type="recommended"
            iconAlign="start"
          />
        </Flex>
      </Card>

      <AlertBanner
        headingSize="h6"
        gap={12}
        title={t("farmGettingStartedForm.infoBanner.title")}
        description={t("farmGettingStartedForm.infoBanner.description")}
        iconName="tabler/info-circle"
        iconSize={24}
        type="info"
        iconAlign="start"
      />
    </Flex>
  );
};

FarmGettingStartedForm.Key = "farm.gettingStarted";
export { FarmGettingStartedForm };
